module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.5d42b4e.ttf";